/**
 * @generated SignedSource<<2927ab2240c3fb83b425c5dc8f1117cc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type RecordType = "GOOGLEPHOTOSAPI" | "WHATSAPPCHAT" | "%future added value";
export type recordsGetRecordsQuery$variables = {
  cursor?: string | null;
  from: any;
  to: any;
};
export type recordsGetRecordsQuery$data = {
  readonly GetRecords: {
    readonly cursor: string | null;
    readonly records: ReadonlyArray<{
      readonly author: string;
      readonly content: {
        readonly files: ReadonlyArray<{
          readonly name: string;
          readonly url: string;
          readonly variant: string;
        }> | null;
        readonly text: string | null;
        readonly url: string | null;
      };
      readonly hash: string;
      readonly id: string;
      readonly registeredAt: any;
      readonly type: RecordType;
    }>;
  };
};
export type recordsGetRecordsQuery = {
  response: recordsGetRecordsQuery$data;
  variables: recordsGetRecordsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cursor"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "from"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "to"
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "cursor",
        "variableName": "cursor"
      },
      {
        "kind": "Variable",
        "name": "from",
        "variableName": "from"
      },
      {
        "kind": "Variable",
        "name": "to",
        "variableName": "to"
      }
    ],
    "concreteType": "RecordSet",
    "kind": "LinkedField",
    "name": "GetRecords",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Record",
        "kind": "LinkedField",
        "name": "records",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hash",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "author",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RecordContent",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "text",
                "storageKey": null
              },
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "RecordFile",
                "kind": "LinkedField",
                "name": "files",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "variant",
                    "storageKey": null
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "registeredAt",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "recordsGetRecordsQuery",
    "selections": (v4/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "recordsGetRecordsQuery",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "8d78f64eea9f8096955b3c464ccc6b7e",
    "id": null,
    "metadata": {},
    "name": "recordsGetRecordsQuery",
    "operationKind": "query",
    "text": "query recordsGetRecordsQuery(\n  $from: DateTime!\n  $to: DateTime!\n  $cursor: String\n) {\n  GetRecords(from: $from, to: $to, cursor: $cursor) {\n    records {\n      id\n      hash\n      type\n      author\n      content {\n        text\n        url\n        files {\n          name\n          variant\n          url\n        }\n      }\n      registeredAt\n    }\n    cursor\n  }\n}\n"
  }
};
})();

(node as any).hash = "16dfc231301ed11c0dc4295fea640d99";

export default node;
